export class SowRetainedTeamStats {
  id!: number
  name!: string
  rateCardId!: number
  countOfScopes!: number
}
